import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonLineUpService {

  constructor(private http: HttpClient) {}

  private refresh$ = new Subject<any>();
  refreshFilter$ = this.refresh$.asObservable();

  private terminalChange$ = new Subject<any>();
  terminalChangeFilter$ = this.terminalChange$.asObservable();

  private rowsChange$ = new Subject<any[]>();
  rowsChangeFilter$ = this.rowsChange$.asObservable();

  private compareMode$ = new Subject<any>();
  compareModeActive$ = this.compareMode$.asObservable();

  private goToRotation$ = new Subject<any>();
  goToRotationEvent$ = this.goToRotation$.asObservable();

  emitCompareMode(active) {
    this.compareMode$.next(active);
  }

  emitGoToRotation(vessel, usedDrawer) {
    this.goToRotation$.next({vessel: vessel, usedDrawer: usedDrawer});
  }

  emitRefresh() {
    this.refresh$.next(true);
  }

  emitTerminalChange(terminalId) {
    this.terminalChange$.next(terminalId);
  }

  emitRowsChange(rows) {
    this.rowsChange$.next(rows);
  }

}